/* eslint-disable class-methods-use-this */
export default class ReCaptcha {
    constructor(config) {
        this.reCaptchaActive = config.reCaptchaActive;
        this.reCaptchaSiteKey = config.reCaptchaSiteKey;
        this.formIDToSubmit = config.formIDToSubmit;
        this.#init();
    }

    #init() {
        globalThis.onSubmitFn = () => this.#onSubmit();
        if (!this.isActive()) {
            return;
        }
        this.#setTokenReCaptcha();
        this.#setReCaptchaScript();
    }

    isActive() {
        return this.reCaptchaActive;
    }

    executeCaptcha(action) {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(this.reCaptchaSiteKey, { action }).then(token => {
                document.getElementById('g-recaptcha-response').value = token;
                globalThis.onSubmitFn();
            });
        });
    }

    #onSubmit() {
        document.getElementById(this.formIDToSubmit).submit();
    }

    #setReCaptchaScript() {
        const scriptNode = document.createElement('script');
        scriptNode.src = `https://www.google.com/recaptcha/api.js?render=${this.reCaptchaSiteKey}`;
        scriptNode.type = 'text/javascript';
        scriptNode.async = true;
        document.querySelector('html head').appendChild(scriptNode);
    }

    #setTokenReCaptcha() {
        document.getElementById(this.formIDToSubmit).insertAdjacentHTML(
            'beforeend',
            `<input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response">`
        );
    }
}
